import { Study, StudyStatusType } from '@faro/study-designer-model';
import { createSafeContext } from '../../../../../util/createSafeContext';

/**
 * Represents study related contextual information needed for proper data loading
 */
export interface StudyContextValue {
    /**
     * ID of the active study
     */
    studyId: string;
    /**
     * The current status type of the study
     */
    statusType: StudyStatusType;

    study: Study;

    /**
     * Indicates if the study is a master study
     */
    isMasterStudy: boolean;

    /**
     * ID of the protocol-import conversation this study was imported from,
     * or undefined when the study was not created via Protocol Import.
     */
    sourceConversationId?: string;
}

export const [StudyContextProvider, useStudyContext, StudyContext] = createSafeContext<StudyContextValue>('Study');
